import { FormBase } from 'core/components';

export default class WarehouseCodesForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			// Every key here is posted as-is (WarehouseCodesViewStore sends form.values() straight through),
			// so warehouseId/channelId are declared too — without warehouseId the API cannot match an
			// existing ConvertWarehouse row and would insert a duplicate instead of updating.
			fields: [
				'warehouseCodes',
				'warehouseCodes[].warehouseName',
				'warehouseCodes[].name',
				'warehouseCodes[].altName',
				'warehouseCodes[].identifierOnChannel',
				'warehouseCodes[].warehouseId',
				'warehouseCodes[].channelId',
			],
			labels: {
				'warehouseCodes[].warehouseName': 'WAREHOUSECODES.WAREHOUSE',
				'warehouseCodes[].name': '',
				'warehouseCodes[].altName': '',
				// Empty like the other in-table inputs — BaasicInput always renders field.label above the input.
				'warehouseCodes[].identifierOnChannel': '',
			},
		};
	}
}
